export default {
    tableCell: {
        borderBottom: 0
    }
};
